
import React from 'react';
import styles from './_message-dialog.module.scss';
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { DialogProps } from '../DialogProps';

export interface MessageDialogProps extends DialogProps<void> {
  title: string;
  message: string | React.ReactNode;
  style?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
}

export default function MessageDialog (props:  MessageDialogProps) {
  const style = props.style || {maxWidth: '360px', maxHeight: '100vh'};
  return (
    <div style={style}>
      <DialogTitle style={{ cursor: 'move' }} id='draggable-dialog-title'>
        {props.title}
      </DialogTitle>
      <DialogContent style={props.contentStyle}>
        <DialogContentText style={{ marginTop: '5px' }}>
          {typeof props.message === 'string' ? props.message : null}
        </DialogContentText>  
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.accept &&
              props.accept();
          }}
          color='primary'
        >
          Ok
        </Button>
      </DialogActions>
    </div>
  );
}
